import * as React from "react";
import { Row, Col, Select, Icon } from "antd";
import styled, { ThemedStyledProps } from "styled-components";
import { SelectProps } from "antd/lib/select";

const Label = styled.span`
  color: #061a32;
  font-size: 11px;
  line-height: 32px;
  font-weight: 300;
`;

const StyledSelect = styled(Select)`
  width: 100%;
  div[role="combobox"] {
    height: 40px !important;
    padding-top: 5px;
    background-color: #f2f2f2 !important;
    border: ${(
      props: ThemedStyledProps<
        SelectProps &
          React.RefAttributes<React.Component<SelectProps, any, any>>,
        any
      > & { hasError: boolean }
    ) => (props.hasError ? "1px solid #eb0333 !important" : "none !important")}
    font-size: 14px !important;
    line-height: 32px !important;
    color: #386ee8 !important;
    font-weight: 300 !important;
  }
`;

type Props = {
  label: string;
  value: any;
  onSelect: (value: any, option: React.ReactElement<any>) => void;
};

export class ForwardSelect extends React.Component<Props> {
  render() {
    return (
      <Row>
        <Col>
          <Label>{this.props.label}</Label>
          <br />
          <StyledSelect
            suffixIcon={<Icon type="down" style={{ color: "#386ee8" }} />}
            dropdownStyle={{ backgroundColor: "#f2f2f2" }}
            onSelect={this.props.onSelect}
            value={this.props.value}
            hasError={!this.props.value}
          >
            {this.props.children}
          </StyledSelect>
        </Col>
      </Row>
    );
  }
}
